import { createAction, props } from '@ngrx/store'

const SOURCE = '[User context]'

export const userContextReset = createAction(`${ SOURCE } userContextReset`)

export const userContextSetProjects = createAction(
    `${ SOURCE } userContextSetProjects`,
    props<{projects: any[]}>()
)

export const userContextSetUser = createAction(
    `${ SOURCE } userContextSetUser`,
    props<{user: any}>()
)

export const userContextSetProjectKeys = createAction(
    `${ SOURCE } UserContextSetProjectKeys`,
    props<{keys: string[]}>()
)

export const userContextSetProject = createAction(
    `${ SOURCE } userContextSetProject`,
    props<{project: any}>()
)

// --- effects

export const setProject = createAction(
    `${ SOURCE } setProject`,
    props<{project: any}>()
)

export const setProjectAfterRefreshAccessToken = createAction(
    `${ SOURCE } setProjectAfterRefreshAccessToken`,
    props<{project: any}>()
)

export const setProjectKeys = createAction(
    `${ SOURCE } setProjectKeys`,
    props<{projectKeys: string[]}>()
)

export const reset = createAction(`${ SOURCE } reset`)
